import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["tooltip"],
  _excluded2 = ["tooltip"];
import React, { forwardRef } from 'react';
import Nav4AppSwitcherIcon from '@atlaskit/icon/core/app-switcher';
import AppSwitcherIcon from '@atlaskit/icon/glyph/app-switcher';
import { IconButton } from '../IconButton';
/**
 * _App switcher__
 *
 * An AppSwitcher button that can be passed into `AtlassianNavigation`'s
 * `renderAppSwitcher` prop.
 *
 * - [Examples](https://atlassian.design/components/atlassian-navigation/examples#app-switcher)
 * - [Code](https://atlassian.design/components/atlassian-navigation/code)
 */
export var AppSwitcher = /*#__PURE__*/forwardRef(function (props, ref) {
  var tooltip = props.tooltip,
    iconButtonProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(IconButton, _extends({
    icon: /*#__PURE__*/React.createElement(AppSwitcherIcon, {
      label: typeof tooltip === 'string' ? tooltip : 'Switch apps'
    }),
    tooltip: tooltip,
    ref: ref
  }, iconButtonProps));
});

// TODO: Fill in the component {description} and ensure links point to the correct {packageName} location.
// Remove links that the component does not have (such as usage). If there are no links remove them all.
/**
 * __App switcher nav 4__
 *
 * An app switcher nav 4 {description}.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */
export var AppSwitcherNav4 = /*#__PURE__*/forwardRef(function (props, ref) {
  var tooltip = props.tooltip,
    iconButtonProps = _objectWithoutProperties(props, _excluded2);
  return /*#__PURE__*/React.createElement(IconButton, _extends({
    icon: /*#__PURE__*/React.createElement(Nav4AppSwitcherIcon, {
      label: typeof tooltip === 'string' ? tooltip : 'Switch apps',
      color: "var(--ds-icon, #44546F)"
    }),
    tooltip: tooltip,
    ref: ref
  }, iconButtonProps));
});

// exists only to extract props
// eslint-disable-next-line @repo/internal/react/use-noop, import/no-anonymous-default-export
export default (function (props) {});